// has to reflect Tamedia AD rules
export const ROLES = {
    EDITOR: 'ROLE_Editor',
    CHIEF_EDITOR: 'ROLE_ChiefEditor',
    ADMIN: 'ROLE_Moderator',
} as const;

export type UserRole = ValueOf<typeof ROLES>;
